// Product Compare
document.addEventListener("DOMContentLoaded", () => {
  window.compareLimit = 3;
  if (sessionStorage.getItem("compare-list")) {
    window.compareIds = JSON.parse(sessionStorage.getItem("compare-list"));
    renderCompareBar();
    updateCompareToggles();
  } else {
    window.compareIds = [];
  }
  document.addEventListener("click", (event) => {
    if (event.target.closest(".js-compare-toggle")) {
      let compareToggle = event.target.closest(".js-compare-toggle");
      event.preventDefault();
      const productId = compareToggle.getAttribute("data-product-id");
      let productTitle = compareToggle.getAttribute("data-product-title");
      let productImage = compareToggle.getAttribute("data-product-image");
      let productUrl = compareToggle.getAttribute("data-product-url");
      let productPrice = compareToggle.getAttribute("data-product-price");

      let isProductExists = window.compareIds.some(product => product.id === productId);
      if (isProductExists) {
        window.compareIds = window.compareIds.filter(product => product.id !== productId);
        sessionStorage.setItem("compare-list", JSON.stringify(window.compareIds));
        compareToggle.classList.remove("active");
      } else {
        if (window.compareIds.length < window.compareLimit && !window.compareIds.some(product => product.id === productId)) {
          window.compareIds.push({
            id: productId,
            title: productTitle,
            image: productImage,
            url: productUrl,
            price: productPrice
          });
          sessionStorage.setItem("compare-list", JSON.stringify(window.compareIds));
          compareToggle.classList.add("active");
          if (document.querySelector('.compare-bottom-bar')) {
            document.querySelector('.compare-bottom-bar').classList.add('fully-shown');
          }
          if (document.querySelector('.js-do-compare') && window.compareIds.length > 1) {
            document.querySelector('.js-do-compare').classList.remove('disabled');
          }
        } else {
          document.dispatchEvent(new CustomEvent("toast:show", {
            detail: {
              message: window.themeVariables.strings.compareYouCanOnlyCompareUpTo.replace("{{ limit }}", window.compareLimit) || `You can only compare up to ${window.compareLimit} products.`
            }
          }));
          return;
        }
      }
      renderCompareBar();
    }

    if (event.target.closest(".js-compare-bottom-toggle")) {
      event.preventDefault();
      if (document.querySelector('.compare-bottom-bar')) {
        document.querySelector('.compare-bottom-bar').classList.toggle('fully-shown');
      }
    }

    if (event.target.closest(".js-compare-remove")) {
      event.preventDefault();
      let productId = event.target.closest(".js-compare-remove").getAttribute("data-product-id");
      if (productId) {
        window.compareIds = window.compareIds.filter(product => product.id !== productId);
        sessionStorage.setItem("compare-list", JSON.stringify(window.compareIds));

        updateCompareToggles();
        renderCompareBar();
      }
    }

    if (event.target.closest(".js-clear-compare")) {
      event.preventDefault();
      window.compareIds = [];
      sessionStorage.setItem("compare-list", JSON.stringify(window.compareIds));
      updateCompareToggles();
      renderCompareBar();
    }

    if (event.target.closest(".js-do-compare")) {
      event.preventDefault();
      if (window.compareIds.length) {
        let searchParams = window.compareIds.map(product => `id:${product.id}`).join(" OR ");
        // ajax to window.themeVariables.routes.searchUrl view=compare to get the response HTML
        if (document.querySelector('#compare-modal')) {
          document.querySelector('#compare-modal').classList.add('start-loading');
        }
        fetch(`${window.themeVariables.routes.searchUrl}?q=${searchParams}&view=compare&type=product`, {
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(response => response.text())
          .then(html => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, "text/html");
            let compareSection = doc.querySelector(".compare-table-wrapper");
            if (compareSection) {
              document.querySelector(".compare-modal-content").innerHTML = compareSection.innerHTML;
              // change order of products in compare-table__cell by index of window.compareIds
              document.querySelectorAll('.compare-table__cell').forEach((cell) => {
                let index = window.compareIds.findIndex(product => product.id === cell.getAttribute('data-product-id'));
                if (index !== -1) {
                  cell.style.order = index + 1;
                }
              });
              document.querySelectorAll('.compare-table__cell-scrolling').forEach((cell) => {
                let index = window.compareIds.findIndex(product => product.id === cell.getAttribute('data-product-id'));
                if (index !== -1) {
                  cell.style.order = index + 1;
                }
              });
              initScrollingElements();
              // add the param compare=1 to the URL, other params should be kept
              let urlParams = new URLSearchParams(window.location.search);
              urlParams.set('compare', '1');
              const params = urlParams.toString();
              const newUrl = params ? `${window.location.pathname}?${params}` : window.location.pathname;
              window.history.replaceState({}, '', newUrl);
            } else {
              document.dispatchEvent(new CustomEvent("toast:show", {
                detail: {
                  message: window.themeVariables.strings.compareNoProductsToCompare || "No products to compare."
                }
              }));
            }
          })
          .catch(error => console.error("Error fetching compare products:", error))
          .finally(() => {
            if (document.querySelector('#compare-modal')) {
              document.querySelector('#compare-modal').classList.remove('start-loading');
            }
          });
      } else {
        document.dispatchEvent(new CustomEvent("toast:show", {
          detail: {
            message: window.themeVariables.strings.compareNoProductsToCompare || "No products to compare."
          }
        }));
      }
    }

    if (event.target.closest(".product-card__metafield-tooltip svg")) {
      let parent = event.target.closest(".product-card__metafield-tooltip");
      parent.classList.toggle("active");
    } else {
      document.querySelectorAll(".product-card__metafield-tooltip").forEach((popup) => {
        popup.classList.remove("active");
      });
    }

    if (event.target.closest(".compare-accordion-header")) {
      let isNextAccordion = false;
      let currentItem = event.target.closest(".compare-accordion-header");
      currentItem.classList.toggle("active");
      while (!isNextAccordion) {
        currentItem = currentItem.nextElementSibling;
        if (currentItem) {
          if (currentItem.classList.contains("compare-accordion-header")) {
            isNextAccordion = true;
          } else {
            currentItem.classList.toggle("active");
          }
        } else {
          isNextAccordion = true;
        }
      }
    }

    // if outside of .compare-bottom-bar and not inside .compare-modal, .js-compare-bottom-toggle-mobile, close the compare modal, remove full-shown class from .compare-bottom-bar
    if (window.innerWidth < 768) {
      if (!event.target.closest('.compare-bottom-bar')
        && !event.target.closest('.compare-modal')
        && !event.target.closest('.compare-modal-content')
        && !event.target.closest('.js-compare-bottom-toggle-mobile')
        && !event.target.closest('.compare-item-remove')
        && !event.target.closest('.js-compare-toggle')
      ) {
        if (document.querySelector('.compare-bottom-bar.fully-shown')) {
          document.querySelector('.compare-bottom-bar.fully-shown').classList.remove('fully-shown');
        }
      }
    }
  });

  document.addEventListener("change", (event) => {
    if (event.target.closest("#compare-floating-filter-input")) {
      let isChecked = event.target.checked;
      if (isChecked) {
        // check .compare-table__cell inside each .compare-table__row, if all inner HTML value is the same, hide the .compare-table__row
        document.querySelectorAll(".compare-table__row").forEach((row) => {
          let cells = row.querySelectorAll(".compare-table__cell");
          if (cells.length > 0) {
            let firstCellInnerHTML = cells[0].innerHTML;
            let isSame = true;
            cells.forEach((cell) => {
              if (cell.innerHTML !== firstCellInnerHTML) {
                isSame = false;
              }
            });
            if (isSame) {
              row.classList.add("hidden");
            } else {
              row.classList.remove("hidden");
            }
          }
        });
        document.querySelectorAll('.compare-accordion-header').forEach((accordion) => {
          console.log(accordion);
          let isNextAccordion = false;
          let rows = [];
          let currentItem = accordion;
          while (!isNextAccordion) {
            currentItem = currentItem.nextElementSibling;
            if (currentItem) {
              if (currentItem.classList.contains("compare-accordion-header")) {
                isNextAccordion = true;
              } else {
                rows.push(currentItem)
              }
            } else {
              isNextAccordion = true;
            }
          }
          // if all rows are hidden, hide the accordion
          if (rows.length > 0) {
            let allRowsHidden = true;
            rows.forEach((row) => {
              if (!row.classList.contains("hidden")) {
                allRowsHidden = false;
              }
            });
            if (allRowsHidden) {
              accordion.classList.add("hidden");
            } else {
              accordion.classList.remove("hidden");
            }
          }
        });
      } else {
        document.querySelectorAll(".compare-table__row").forEach((row) => {
          row.classList.remove("hidden");
        });
        document.querySelectorAll('.compare-accordion-header').forEach((accordion) => {
          accordion.classList.remove("hidden");
        });
      }
    }
  });

  async function initScrollingElements() {
    await new Promise(resolve => setTimeout(resolve, 200));
    let compareModal = document.querySelector('#compare-modal');
    let compareTable = document.querySelector('.compare-table');
    if (compareModal && compareTable && !compareTable.classList.contains('initialized')) {
      let titleAndImage = document.querySelector('.compare-title-and-image');

      // Get the scrollable element inside the modal's shadow DOM
      let scrollableElement = compareModal.shadowRoot?.querySelector('[part="body"]');

      // If shadow DOM is not accessible, try the modal element itself
      if (!scrollableElement) {
        scrollableElement = compareModal;
      }

      let threshold = 300;
      let totalHeightTopContent = 0;
      let allRows = document.querySelectorAll('.compare-table__row');
      let count = 0;
      allRows.forEach((row) => {
        totalHeightTopContent += row.offsetHeight;
        count++;
        if (count >= 3) {
          return;
        }
      });
      if (document.querySelector('.compare-modal-header')) {
        totalHeightTopContent = totalHeightTopContent + document.querySelector('.compare-modal-header').offsetHeight;
      }
      if (totalHeightTopContent > 300) {
        threshold = totalHeightTopContent + 20;
      }

      let isVisible = false;
      const showThreshold = threshold + 60;
      const hideThreshold = threshold - 60;

      scrollableElement.addEventListener('scroll', (event) => {
        if (!titleAndImage) return;

        const scrollTop = event.target.scrollTop;
        // Use hysteresis to prevent flickering
        if (scrollTop > showThreshold && !isVisible) {
          titleAndImage.classList.remove('hide');
          isVisible = true;
        } else if (scrollTop < hideThreshold && isVisible) {
          titleAndImage.classList.add('hide');
          isVisible = false;
        }
      });

      if (document.querySelector('.compare-modal-content')) {
        if (!titleAndImage) return;

        // Optimize children access and add GPU acceleration hints
        const children = Array.from(titleAndImage.children);
        children.forEach(child => {
          child.style.willChange = 'transform';
          child.style.backfaceVisibility = 'hidden';
          child.style.perspective = '1000px';
        });

        let ticking = false;

        // listen to horizontal scroll event of .compare-modal-content
        document.querySelector('.compare-modal-content').addEventListener('scroll', (event) => {
          const scrollLeft = event.target.scrollLeft;

          if (!ticking) {
            requestAnimationFrame(() => {
              // Use translate3d for GPU acceleration instead of translateX
              children.forEach(child => {
                child.style.transform = `translate3d(-${scrollLeft}px, 0, 0)`;
              });
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
      }

      compareTable.classList.add('initialized');

      compareModal.addEventListener('dialog:after-hide', () => {
        // remove the param compare=1 from the URL, if other params are present, keep them. replace state not push state
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('compare');
        const params = urlParams.toString();
        const newUrl = params ? `${window.location.pathname}?${params}` : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      })
    }
  }

  function renderCompareBar() {
    // console.log(window.compareIds);
    if (window.compareIds && window.compareIds.length) {
      document.querySelector('.js-compare-bottom-toggle-mobile').classList.add('active');
      document.querySelectorAll('.compare-count').forEach((count) => {
        count.textContent = `(${window.compareIds.length})`;
      });
      // fill the compare bar with products
      let compareListElm = document.querySelector('.compare-bottom-bar .compare-list');
      if (compareListElm) {
        // set all li to original state with placeholder text from data-placeholder
        compareListElm.querySelectorAll('li').forEach((li) => {
          let placeholderText = li.getAttribute('data-placeholder') || "Select product to compare";
          li.innerHTML = placeholderText;
        });
        window.compareIds.forEach((product, index) => {
          // fill in <li> of compareListElm follow index
          let li = compareListElm.querySelector(`li:nth-child(${index + 1})`);
          if (li) {
            li.innerHTML = `
              <div class="compare-item h-stack gap-2 align-center justify-start">
                ${product.image ? `<img src="${product.image}" alt="${product.title}" class="compare-item-image">` : ""}
                <div class="compare-item-title-wrapper v-stack gap-2 justify-start">
                  <a href="${product.url}" class="compare-item-title" title="">${product.title}</a>
                  <span class="compare-item-price">${product.price}</span>
                </div>
                <a href="#" class="compare-item-remove js-compare-remove text-start link" data-product-id="${product.id}">
                  <svg aria-hidden="true" focusable="false" width="10" class="" part="icon" fill="#000000" viewBox="0 0 10 10">
                    <path stroke="currentColor" d="m1 1 8 8m0-8L1 9" />
                  </svg>
                </a>
              </div>
            `;
          }
        });
      }
      if (document.querySelector('.compare-bottom-bar')) {
        document.querySelector('.compare-bottom-bar').classList.remove('hidden');
        document.body.classList.add('compare-bottom-bar-active');

        if (window.compareIds.length > 1) {
          document.querySelector('.js-do-compare').classList.remove('disabled');
        } else {
          document.querySelector('.js-do-compare').classList.add('disabled');
        }

        // open the compare table if customer go back to the page with the param compare=1
        if (window.location.search.includes('compare=1')) {
          document.querySelector('.compare-bottom-bar').classList.add('fully-shown');
          setTimeout(() => {
            document.querySelector('.js-do-compare')?.click();
          }, 100)
        }
      }
    } else {
      if (document.querySelector('.compare-bottom-bar')) {
        document.querySelector('.compare-bottom-bar').classList.remove('fully-shown');
        document.querySelector('.compare-bottom-bar').classList.add('hidden');
        document.body.classList.remove('compare-bottom-bar-active');
      }
      document.querySelector('.js-compare-bottom-toggle-mobile').classList.remove('active');
    }
  }

  function updateCompareToggles() {
    if (window.compareIds) {
      document.querySelectorAll('.js-compare-toggle').forEach((toggle) => {
        let productId = toggle.getAttribute('data-product-id');
        if (window.compareIds.some(product => product.id === productId)) {
          toggle.classList.add('active');
        } else {
          toggle.classList.remove('active');
        }
      });
    }
  }

  document.addEventListener('update-compare', function() {
    if (sessionStorage.getItem("compare-list")) {
      window.compareIds = JSON.parse(sessionStorage.getItem("compare-list"));
      renderCompareBar();
      updateCompareToggles();
    } else {
      window.compareIds = [];
    }
  });
});


// Back to top: smooth scroll to main/top on footer link activation
document.addEventListener("DOMContentLoaded", () => {
  const onBackToTop = (event) => {
    const trigger = event.target && event.target.closest && event.target.closest(".back-to-top_link");
    if (!trigger) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  document.addEventListener("click", onBackToTop);

  document.addEventListener("keydown", (event) => {
    if ((event.key === " " || event.key === "Spacebar") && event.target && event.target.closest && event.target.closest(".back-to-top_link")) {
      event.preventDefault();
      onBackToTop(event);
    }
  });
});

/**
 * Scroll Fade Effect
 * Creates a fade overlay on the right edge of horizontally scrollable elements.
 * Fades out as the user scrolls toward the end of the content.
 *
 * @param {Object} options
 * @param {string} options.scrollElementId - ID of the scrollable element
 * @param {string} options.wrapperElementId - ID of the wrapper element (for positioning)
 * @param {string} [options.fadeClass='scroll-fade'] - CSS class for the fade element
 */
window.initScrollFade = function(options) {
  const { scrollElementId, wrapperElementId, fadeClass = 'scroll-fade' } = options;
  const scrollEl = document.getElementById(scrollElementId);
  const wrapper = document.getElementById(wrapperElementId);

  if (!scrollEl || !wrapper) return;

  const fade = document.createElement('div');
  fade.className = fadeClass;
  wrapper.appendChild(fade);

  const getFadeWidth = () => window.innerWidth >= 769 ? 150 : 75;

  const updateFade = () => {
    const scrollRect = scrollEl.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const scrollWidth = scrollEl.scrollWidth;
    const clientWidth = scrollEl.clientWidth;
    const maxScroll = scrollWidth - clientWidth;

    // Position fade at right edge of scroll element's visible area
    fade.style.right = (wrapperRect.right - scrollRect.right) + 'px';
    fade.style.height = scrollRect.height + 'px';

    // Hide when no overflow or scrolled to end
    if (maxScroll <= 0) {
      fade.style.opacity = '0';
      return;
    }

    const remaining = maxScroll - scrollEl.scrollLeft;
    const fadeWidth = getFadeWidth();
    const progress = Math.max(0, Math.min(1, 1 - (remaining / fadeWidth)));
    fade.style.opacity = String(1 - progress);
  };

  scrollEl.addEventListener('scroll', updateFade, { passive: true });
  window.addEventListener('resize', updateFade, { passive: true });
  updateFade();
};

// Kolli Quantity Cart Validator
(function() {
  let isProcessing = false;

  function getKolliLineItems() {
    return Array.from(document.querySelectorAll('line-item[data-kolli-antal]'));
  }

  function getLineItemInfo(lineItemEl) {
    const kolliAntal = parseInt(lineItemEl.getAttribute('data-kolli-antal'), 10);
    const input = lineItemEl.querySelector('input[data-line-key]');
    if (!input || !kolliAntal || kolliAntal <= 1) return null;

    return {
      lineKey: input.getAttribute('data-line-key'),
      quantity: parseInt(input.value, 10),
      kolliAntal
    };
  }

  async function changeCartItem(lineKey, quantity) {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    return fetch(`${Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity, sections: sectionsToBundle.join(',') })
    });
  }

  async function validateCart() {
    if (!window.themeVariables?.settings?.enableKolliQuantity) return;
    if (isProcessing) return;

    const lineItems = getKolliLineItems();
    const corrections = [];

    for (const el of lineItems) {
      const info = getLineItemInfo(el);
      if (!info) continue;

      const { lineKey, quantity, kolliAntal } = info;

      if (quantity > 0 && quantity < kolliAntal) {
        corrections.push({ lineKey, newQuantity: 0, reason: 'below_minimum', kolliAntal });
      } else if (quantity > 0 && quantity % kolliAntal !== 0) {
        const corrected = Math.floor(quantity / kolliAntal) * kolliAntal;
        corrections.push({ lineKey, newQuantity: corrected, reason: 'not_multiple', kolliAntal });
      }
    }

    if (corrections.length === 0) return;

    isProcessing = true;
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      for (const correction of corrections) {
        const response = await changeCartItem(correction.lineKey, correction.newQuantity);
        if (!response.ok) continue;

        const message = correction.reason === 'below_minimum'
          ? `Item removed — minimum quantity is ${correction.kolliAntal}`
          : `Quantity adjusted to ${correction.newQuantity} (must be a multiple of ${correction.kolliAntal})`;

        document.dispatchEvent(new CustomEvent('toast:show', { detail: { message } }));
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      setTimeout(() => { isProcessing = false; }, 1000);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(validateCart, 500);
  });

  document.addEventListener('cart:change', () => {
    setTimeout(validateCart, 800);
  });
})();
